<template>
  <div class="row mx-0 bg-white shadow mb-2 py-2">
    <div class="col my-auto">{{ benutzer.name != '' ? benutzer.name : user?.benutzername }}</div>
    <div class="col my-auto">{{ user?.username }}</div>
    <div class="col my-auto">{{ user?.email }}</div>
    <div class="col-1 my-auto">{{ benutzer.isAdmin ? 'Admin' : 'Benutzer' }}</div>
    <div class="col-1 my-auto">{{ benutzer.canSign ? 'Ja' : 'Nein' }}</div>

    <div class="col-1 my-auto text-end">
      <EditBenutzerModal :benutzer="benutzer" :index="index" :button-style="1" @delete-benutzer="deleteBenutzerRequest" />
    </div>
  </div>

  <ConfirmationAlert ref="confirmationAlertRef" @confirm="deleteBenutzer" />
</template>

<script lang="ts" setup>
  //#region Imports
  import { PropType, computed, ref } from 'vue';
  import { useStore } from '@/store';
  import { Benutzer } from '@/models/AuthModels';

  import { ActionTypes as AuthActionTypes } from '@/store/modules/Auth/actions';

  import EditBenutzerModal from './EditBenutzerModal.vue';
  import ConfirmationAlert from '@/components/ConfirmationAlert.vue';
  //#endregion

  const { benutzer, index } = defineProps({
    benutzer: {
      type: Object as PropType<Benutzer>,
      required: true,
    },

    index: {
      type: Number as PropType<number>,
      required: true,
    },
  });

  const store = useStore();

  const user = computed(() => store.getters.archivUsers.find((u) => u.id === benutzer.identityUserId));

  //#region DELETE
  const confirmationAlertRef = ref();

  function deleteBenutzerRequest(benutzerId: number) {
    confirmationAlertRef.value?.showAlert(
      'Benutzer löschen',
      'Möchten Sie den Benutzer unwiderruflich lösche?',
      benutzerId.toString(),
      '',
      'danger',
      'text-white'
    );
  }

  function deleteBenutzer(benutzerId: string) {
    store.dispatch(AuthActionTypes.RemoveBenutzer, Number.parseInt(benutzerId));
  }
  //#endregion
</script>
